import { createContext } from 'react';
export const NavigationComponentContext = /*#__PURE__*/createContext(undefined);